// Wspólny układ ekranów logowania (logowanie, brak dostępu): z lewej panel marki, z prawej karta.
// Ten sam wygląd ma szablon strony Azure B2C (public/b2c/), żeby przejście było płynne.
import type { ReactNode } from "react";

export const AuthLayout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col md:flex-row bg-[var(--sc-bg)]">
    <aside className="md:w-[44%] md:min-h-screen bg-[var(--sc-navbar)] text-white flex flex-col justify-between px-8 py-8 md:px-14 md:py-12">
      <img src="/logo_dark_mode.png" alt="Scientia" className="h-12 md:h-14 w-auto self-start -ml-2" />
      <div className="hidden md:block">
        <h1 className="text-[34px] font-light leading-tight tracking-[-0.02em] m-0">Scientia Reports</h1>
        <p className="text-[14px] text-white/55 mt-3 max-w-[360px] leading-relaxed">
          Raporty z wizyt monitorujących, rejestr ośrodków i kalendarz wizyt w jednym miejscu.
        </p>
      </div>
      <span className="hidden md:block text-[10px] uppercase tracking-[0.18em] text-white/35">
        Providing the best in clinical research
      </span>
    </aside>
    <main className="flex-1 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-[380px] rounded-[var(--sc-radius-lg)] border border-[var(--sc-border)] bg-[var(--sc-surface)] px-7 py-8 shadow-[0_8px_30px_rgba(0,0,0,0.05)]">
        {children}
      </div>
    </main>
  </div>
);

export const ALLOWED_DOMAINS_TEXT = "@scientiacro.com lub @scientiari.com";
